(function (angular) {
    'use strict';

    angular.module('integration')

        /**
         *
         */
        .factory('integrationModalHelperService', ["$uibModal", function ($uibModal) {

            var fac = {

                /**
                 * 
                 */
                openAccessTokenWizard: function (accessTokenData) {
                    return $uibModal.open({
                        animation: true,
                        size: 'lg',
                        templateUrl: 'components/platformConfiguration/integration/templates/createAccessTokenModal.html',
                        controller: 'accessTokenWizardModal',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        keyboard: false,
                        resolve: {
                            availablePermissions: ['$q', '$stateParams', 'accessTokenService', function ($q, $stateParams, accessTokenService) {
                                return accessTokenService.getAvailablePermissions($stateParams.pickedApiSpaceId)
                                    .then(function (result) {
                                        return result;
                                    }).catch(function (result) {
                                        var deferred = $q.defer();
                                        if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                        return deferred.promise;
                                    });
                            }],
                            availableTemplates: ['$q', '$stateParams', 'accessTokenService', function ($q, $stateParams, accessTokenService) {
                                return accessTokenService.getAvailableTemplates($stateParams.pickedApiSpaceId)
                                    .then(function (result) {
                                        return result;
                                    }).catch(function (result) {
                                        var deferred = $q.defer();
                                        if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                        return deferred.promise;
                                    });
                            }],
                            accessTokenData: [function () {
                                return accessTokenData;
                            }]
                        }
                    });

                },

                /**
                 * 
                 */
                openAccessTokenModal: function (accessToken) {
                    return $uibModal.open({
                        animation: true,
                        size: 'lg',
                        templateUrl: 'components/platformConfiguration/integration/templates/viewAccessTokenModal.html',
                        controller: 'viewAccessTokenModal',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        keyboard: false,
                        resolve: {
                            accessToken: [function () {
                                return accessToken;
                            }],
                            availablePermissions: ['$q', '$stateParams', 'accessTokenService', function ($q, $stateParams, accessTokenService) {
                                return accessTokenService.getAvailablePermissions($stateParams.pickedApiSpaceId)
                                    .then(function (result) {
                                        return result;
                                    }).catch(function (result) {
                                        var deferred = $q.defer();
                                        if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                        return deferred.promise;
                                    });
                            }],
                            availableTemplates: ['$q', '$stateParams', 'accessTokenService', function ($q, $stateParams, accessTokenService) {
                                return accessTokenService.getAvailableTemplates($stateParams.pickedApiSpaceId)
                                    .then(function (result) {
                                        return result;
                                    }).catch(function (result) {
                                        var deferred = $q.defer();
                                        if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                        return deferred.promise;
                                    });
                            }],

                        }
                    });

                },

                /**
                 * 
                 * @param {*} webhook 
                 */
                openWebhookModal: function (webhook, useBatch) {
                    return $uibModal.open({
                        animation: true,
                        size: 'lg',
                        templateUrl: 'components/platformConfiguration/integration/templates/webhookModal.html',
                        controller: 'webhookModal',
                        controllerAs: 'vm',
                        backdrop: 'static',
                        resolve: {
                            availableEvents: ['$q', '$stateParams', 'webhooksService', function ($q, $stateParams, webhooksService) {
                                return webhooksService.getAvailableEvents($stateParams.pickedApiSpaceId)
                                    .then(function (result) {
                                        return result;
                                    }).catch(function (result) {
                                        var deferred = $q.defer();
                                        if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                        return deferred.promise;
                                    });
                            }],
                            availableTemplates: ['$q', '$stateParams', 'webhooksService', function ($q, $stateParams, webhooksService) {
                                return webhooksService.getAvailableTemplates($stateParams.pickedApiSpaceId)
                                    .then(function (result) {
                                        return result;
                                    }).catch(function (result) {
                                        var deferred = $q.defer();
                                        if (result.status < 500) { deferred.resolve(result); } else { deferred.reject(result); }
                                        return deferred.promise;
                                    });
                            }],
                            webhook: [function () {
                                return webhook;
                            }],
                            useBatch:[function () {
                                return useBatch;
                            }], 
                        }
                    });

                }

            };

            return fac;
        }]);

})(window.angular);
